import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-139">
      <Header data-id="element-140" />
      <Outlet data-id="element-141" />
      <Footer data-id="element-142" />
    </div>;
}